import OrderPhotosModal from './OrderPhotosModal';

export default OrderPhotosModal;
